
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fetchTranslations,{ getTranslate } from '../../service/action/actioncreator/CommonAction/Common';



i18n
.use(initReactI18next)  // Integrate with React
.init({
  lng: 'it',  // Default language is Italian
  fallbackLng: 'en',  // Fallback language
  resources: {},  // Will be populated dynamically
  interpolation: {
    escapeValue: false,  // React already escapes values
  },
  // ns: ['labels'], 
  //    defaultNS: 'labels'
});

export default i18n;
